/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import '../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "CreditLimitAdjustmentOffer": {
                "fields": {
                  "identifier": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "effectiveDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "minCreditLimit": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "maxCreditLimit": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "autoAppliedOnDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLimitAdjustmentOffer) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreditLimitAdjustmentOffer @ squareup/corporate_card/resources/credit_limit_adjustment_offer.proto at 9:1
 */
export const CreditLimitAdjustmentOffer = $root.lookupType('squareup.corporate_card.resources.CreditLimitAdjustmentOffer');
fixType(CreditLimitAdjustmentOffer, {
  identifier: {
    required: true
  },
  effectiveDate: {
    required: true
  },
  minCreditLimit: {
    required: true
  },
  maxCreditLimit: {
    required: true
  },
  autoAppliedOnDate: {
    required: true
  }
});
Builder.createAndAttachToType(CreditLimitAdjustmentOffer);